import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MessageService } from './message.service';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { Cookie } from 'ng2-cookies';
import { OnInit } from '@angular/core';
import { AppSettingsService } from './app-settings.service';
@Injectable({
  providedIn: 'root'
})
export class FlowsService  {

 	constructor(private _http: Http,  private messageService: MessageService){}



  onError(err) {
    this.messageService.add('Error en comunicación con servicio de flujos');  
    return throwError(err);
 }

  getFlows (dateProc): Observable<any> {
    const url =  AppSettingsService.settings.apiUrl+'/load-bi/flows/'+dateProc;
    var headers = new Headers({'Authorization': 'Bearer '+Cookie.get('access_token')});
    var options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
       .pipe(map(res => res.json()), 
       catchError(err => this.onError(err)) ); 
  }  
}